__turbopack_context__.v({
  "socialBtn": "SocialLinks-module-scss-module__lG-lTa__socialBtn",
  "socials": "SocialLinks-module-scss-module__lG-lTa__socials",
});
